import { useEffect } from 'react';

export default function useOnMount(effectFn: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(effectFn, []);
}
